<!--
패킹 컴포넌트 > 포장요청
------------------------------------
-->
<template>
    <div class="root">

        <div class="item pack-type" :class="house.pack_type > 0 ? 'highlight' : null">
            <div class="header">
                포장<br />방법
            </div>
            <div class="body">
                <div v-if="house.pack_type === 0">
                    신청안함(작업자임의)
                    <br />
                    <div class="pack-type-default-guide">
                        [의류/신발은 겉박스 제거, 신발박스+폴리백 포장]
                    </div>

                </div>
                <div v-if="house.pack_type !== 0">
                    {{ house.pack_type_text }}
                </div>

            </div>
        </div>


        <div class="item safety-pack-type" :class="highlightSafetyPackType ? 'highlight' : null">
            <div class="header">
                안전<br />포장
            </div>
            <div class="body">
                {{ house.safety_pack_type_text }}
            </div>
        </div>

        <div class="item pack-request" :class="house.pack_request ? 'highlight' : null">
            <div class="header">
                포장<br />요청사항
            </div>
            <div class="body" v-html="packRequestBr">
            </div>
        </div>



    </div>

</template>

<script>
export default {
    components: {
        'request': require('../tracking-check/request-2405.vue').default,
    },
    props: {
        // 하우스 정보
        house: {
            type: Object,
            default: null,
        },
    },
    data: function () {
        return {};
    },
    computed: {
        /**
         * br 태그 적용
         * @returns {string}
         */
        packRequestBr() {
            if (this.house.pack_request === null) {
                return '';
            }
            return this.house.pack_request.replace(/(?:\r\n|\r|\n)/g, '<br />');
        },
        /**
         * 안전포장 강조
         * @returns {string}
         */
        highlightSafetyPackType() {
            return this.house.safety_pack_type === 1;
        },
    },
    methods: {},
}
</script>

<style lang="scss" scoped>
.root {
    //background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: start;

}

.item {
    margin-right: 1rem;
    &:last-child {
        margin-right: 0;
    }



    display: flex;

    .header {
        background-color: #fafafa;
        border: 1px solid #cfcfcf;
        padding: 5px 1rem;
        text-align: center;
    }

    .body {
        border: 1px solid #cfcfcf;
        border-left: 0;
        background-color: #fff;
        padding: 5px;
        color: #999;
        font-size: 1rem;
        text-align: center;
        flex-grow: 1;
        min-width: 6rem;
    }

    .header, .body {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    &.highlight .body {
        color: #000;
        background-color: #ffffcc;
        font-weight: bold;
    }

    &.safety-pack-type.highlight .body {
        background-color: #FFE699;
    }

    &.pack-type.highlight .body,
    &.safety-pack-type.highlight .body {
        font-size: 1.5rem;
    }

    &.pack-type {

    }
    &.safety-pack-type {

    }
    &.pack-request {

    }


}


// 포장옵션 기본 안내문구
.pack-type-default-guide {
    background-color: #ffff06;
    color: #000;
}
</style>